import { create } from "mutative";
import { useStore } from "../../config/store";
import { getEditOrder } from "./getEditOrder";
import { fns, libTypes } from "@holta/lib";
import { getMergedOrder } from "./getMergedOrder";
import { getMergedOrderItem } from "./getMergedOrderItem";



export const setCarcaseItemDepth = (depth: number) => {
    
    const editOrder = getEditOrder();
    const mergedOrder = getMergedOrder();
    const mergedOrderItem = getMergedOrderItem();

    
    if (mergedOrderItem && fns.order_item.isCarcaseItem(mergedOrderItem)) {

        const currentOrderItem = mergedOrder.items.find((item) => item.id === mergedOrderItem.id) as libTypes.CarcaseOrderItem;

        if (currentOrderItem && currentOrderItem?.dEdited === depth || currentOrderItem?.d === depth) {
            useStore.setState({
                editOrder: create(editOrder, draft => {
                    (draft.newValues.orderItem as libTypes.EditedCarcaseOrderItem).dEdited = null;
                })
            });
        } else if (mergedOrderItem.d === depth) {
            useStore.setState({
                editOrder: create(editOrder, draft => {
                    (draft.newValues.orderItem as libTypes.EditedCarcaseOrderItem).dEdited = null;
                })
            });
        } else {
            useStore.setState({
                editOrder: create(editOrder, draft => {
                    (draft.newValues.orderItem as libTypes.EditedCarcaseOrderItem).dEdited = fns.order_item.set.dEdited(depth);
                })
            });
            
        }
    }

};